import React from 'react';
import Section from '../ui/Section';

const About = () => {
  return (
    <Section id="about" className="border-b border-brand-text/10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        
        {/* Исправлено: добавлено lg: перед sticky и top-32, а также отступы для мобилки */}
        <div className="lg:col-span-4 lg:sticky lg:top-32 h-fit mb-12 lg:mb-0">
          <h2 className="text-4xl md:text-5xl leading-none">
            ÜBER UNS
          </h2>
          <div className="mt-8 font-mono text-xs uppercase tracking-widest text-brand-text/50">
            Tradition trifft Serie
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="text-2xl md:text-3xl font-inter leading-snug mb-16 text-balance">
            Die Bauwirtschaft befindet sich in einem massiven Wandel. Wir verbinden jahrzehntelange Praxis-Expertise mit modernster industrieller Serienschöpfung.
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 font-inter mb-16">
            <div>
              <p className="text-brand-text/80 leading-relaxed mb-6">
                Klassische Methoden stoßen zunehmend an Grenzen: Preissteigerungen, unberechenbare Witterung und Fachkräftemangel machen das Bauen in gewohnter Massivbauweise ineffizient und schwer planbar.
              </p>
              <p className="text-brand-text/80 leading-relaxed mb-8">
                Mit 51north verändern wir grundlegend die Art und Weise, wie Häuser realisiert werden. Unser Anspruch: Den Traum vom Eigenheim bezahlbar gestalten — in kompromisslos hoher Qualität und transparenter Kostensicherheit.
              </p>
            </div>

            <div className="bg-brand-text/5 p-8 border border-brand-text/10">
              <h4 className="font-mono text-xs uppercase tracking-widest text-brand-text/50 mb-6">Unsere Fundamente</h4>
              <ul className="space-y-6 font-mono text-sm border-t border-brand-text/10 pt-4">
                <li className="flex justify-between items-center border-b border-brand-text/10 pb-4">
                  <span className="uppercase text-brand-text/50">Erfahrung</span>
                  <span className="text-right">&gt;100 Häuser / Jahr</span>
                </li>
                <li className="flex justify-between items-center border-b border-brand-text/10 pb-4">
                  <span className="uppercase text-brand-text/50">Expertise</span>
                  <span className="text-right">Seit 1997 am Markt</span>
                </li>
                <li className="flex justify-between items-center">
                  <span className="uppercase text-brand-text/50">Fokus</span>
                  <span className="text-right">Systemarchitektur</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Quote Block */}
          <div className="border-l-2 border-brand-text pl-6 md:pl-10 py-2">
            <p className="text-xl md:text-2xl font-inter italic text-brand-text/90 leading-relaxed mb-6">
              „Seit 1997 kenne ich das Baugeschäft aus erster Hand. Doch die heutigen Rahmenbedingungen machen den traditionellen Hausbau oft unkalkulierbar. Mit 51north nehmen wir Ihnen das Risiko ab: Wir bauen Ihr Eigenheim in industrieller Präzision – schneller, sicherer und zum garantierten Preis.“
            </p>
            <p className="font-mono text-xs uppercase tracking-widest text-brand-text/50">
              — Ronny Müller, Co-Founder &amp; Managing Partner
            </p>
          </div>

        </div>
      </div>
    </Section>
  );
};

export default About;